import React from "react";
import { LucideIcon } from "lucide-react";
import { cn } from "../../lib/utils";

interface QuickActionButtonProps {
  icon: LucideIcon;
  label: string;
  onClick?: () => void;
  variant?: "primary" | "secondary";
}

const QuickActionButton = ({
  icon: Icon,
  label,
  onClick,
  variant = "primary",
}: QuickActionButtonProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "flex flex-col items-center justify-center rounded-xl shadow-md transition duration-300",
        variant === "primary"
          ? "bg-[#885ABB] text-white h-24 hover:bg-[#7748A4]"
          : "bg-white text-[#402B69] h-16 border border-gray-200 hover:border-[#885ABB]/40 hover:bg-[#FAF7FD]"
      )}
    >
      <Icon className={cn("w-5 h-5", variant === "secondary" && "text-[#885ABB]")} />
      <span className={cn("font-medium mt-1", variant === "primary" ? "text-sm" : "text-xs")}>
        {label}
      </span>
    </button>
  );
};

export default QuickActionButton;
